import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Calendar } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageMeta from '@/components/PageMeta';
interface BlogPost {
  id: string;
  title: string;
  excerpt: string | null;
  content: string;
  image_url: string | null;
  created_at: string;
}

const Aktuelt = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      const { data } = await supabase
        .from('blog_posts')
        .select('*')
        .eq('published', true)
        .order('created_at', { ascending: false });

      setPosts(data || []);
      setLoading(false);
    };

    fetchPosts();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta
        title="Aktuelt – Nyheter og oppdateringer"
        description="Les siste nytt fra Bunadstuggu. Nyheter om bunader, arrangementer, tilbud og oppdateringer fra vår butikk i Levanger."
        path="/aktuelt"
      />
      <Header />
      <main className="flex-1 pt-32 pb-20 bg-cream">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-charcoal text-center mb-4">
            Aktuelt
          </h1>
          <p className="text-charcoal/70 text-center mb-12 max-w-2xl mx-auto">
            Siste nytt fra Bunadstuggu
          </p>

          {loading ? (
            <div className="flex justify-center">
              <p className="text-charcoal/60">Laster...</p>
            </div>
          ) : posts.length === 0 ? (
            <p className="text-charcoal/60 text-center">Ingen publiserte innlegg ennå.</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {posts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blogg/${post.id}`}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 block"
                >
                  {post.image_url && (
                    <div className="aspect-video overflow-hidden">
                      <img
                        src={post.image_url}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-sm text-charcoal/60 mb-3">
                      <Calendar className="w-4 h-4" />
                      {new Date(post.created_at).toLocaleDateString('nb-NO', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      })}
                    </div>
                    <h3 className="text-xl font-serif text-charcoal mb-3">
                      {post.title}
                    </h3>
                    <p className="text-charcoal/70 line-clamp-3">
                      {post.excerpt || post.content.substring(0, 150)}...
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Aktuelt;
